import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { popupIcon } from 'Assets/Icons'
import Loader from 'Components/Loader'
import { DialogModal } from 'Components/UIComponents'
import { commonMethods } from 'Utils/commonMethods'
import { Dropdown } from 'primereact/dropdown'
import HistoryDataPopUp from './HistoryDataPopUp'

const GlobalRawCoffeePrices = ({ setLoading, mockGlobalCoffeePrices, mockGlobalRawCoffeePrice }) => {
  const { t } = useTranslation()

  const [globalRawCoffeePrice, setGlobalRawCoffeePrice] = useState([])
  const [noDataFound, setNoDataFound] = useState(false)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [countryList, setCountryList] = useState([])
  const [errorMessage, setErrorMessage] = useState(false)
  const [selectedQualityForHistoryData, setSelectedQualityForHistoryData] = useState([])
  const [editableRowIndexs, setEditableRowIndexs] = useState(null)
  const [updatedPriceDetails, setUpdatedPriceDetails] = useState({
    qualityName: '',
    rangeStart: '',
    rangeEnd: '',
    convertedRangeStart: '',
    convertedRangeEnd: '',
    remarks: ''
  })

  const [modalState, setModalState] = useState({
    showModal: false,
    message: '',
    modalType: '',
    softAction: ''
  })

  useEffect(() => {
    fetchGlobalRawCoffeePriceOrderByCurrency()

    // for testing purpose
    if (mockGlobalCoffeePrices) {
      setGlobalRawCoffeePrice(mockGlobalRawCoffeePrice)
    }
  }, [])

  const fetchGlobalRawCoffeePriceOrderByCurrency = async (countryId = 102) => {
    setLoading(true)
    try {
      const { data } = await apiAdapterCoffeeWeb.getGlobalCoffeePriceForUsers(countryId)

      const globalCoffeePrice = data.returnLst?.globalCoffeePriceDTOs
      const coffeePriceCountryList = data.returnLst?.globalCoffeePriceCountryList

      if (globalCoffeePrice?.length > 0) {
        setGlobalRawCoffeePrice(globalCoffeePrice)
        setNoDataFound(false)
        setCountryList(coffeePriceCountryList)
        if (countryId === 102) {
          setSelectedCountry(coffeePriceCountryList?.find((ele) => ele?.id === 102))
        }
      } else {
        setGlobalRawCoffeePrice([])
        setNoDataFound(true)
      }
    } catch (error) {
      setNoDataFound(true)
      setGlobalRawCoffeePrice([])
    } finally {
      setLoading(false)
      window.scrollTo({ top: 0 })
    }
  }

  const handleSelectQualityName = (...items) => {
    setSelectedQualityForHistoryData(items)
    setEditableRowIndexs(null)
  }

  const handleClickEditButton = (...indexs) => {
    const [i0, i1, i2, i3] = indexs

    const priceData = globalRawCoffeePrice[i0]?.cropyear[i1]?.globalCoffeePriceDTOs[i2]?.globalCoffeePriceData[i3]

    const { qualityName, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks } = priceData

    setEditableRowIndexs(indexs)
    setUpdatedPriceDetails({ qualityName, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks })
  }

  const handleClickCancelButton = () => {
    setEditableRowIndexs(null)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target

    setUpdatedPriceDetails((prev) => ({ ...prev, [name]: value }))
  }

  const handleClickSaveButton = async () => {
    const { qualityName, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks } = updatedPriceDetails

    const isEmpty = !qualityName || !rangeStart || !rangeEnd || !convertedRangeStart || !convertedRangeEnd || !remarks

    if (isEmpty) return

    setLoading(true)

    const [row0, row1, row2, row3] = editableRowIndexs

    const countryData = globalRawCoffeePrice[row0]
    const cropYearData = countryData.cropyear[row1]
    const coffeeDTO = cropYearData.globalCoffeePriceDTOs[row2]
    const coffeeData = coffeeDTO.globalCoffeePriceData[row3]

    const payload = {
      id: coffeeData.id,
      idCountry: selectedCountry.id,
      countryName: countryData.country,
      qualityGroup: coffeeDTO.qualityGroupName,
      qualityName: coffeeData.qualityName,
      rangeStart: updatedPriceDetails.rangeStart,
      rangeEnd: updatedPriceDetails.rangeEnd,
      remarks: updatedPriceDetails.remarks,
      cropYear: cropYearData.cropyear,
      terminal: coffeeDTO.terminal,
      forexType: coffeeDTO.forexType,
      forexValue: coffeeDTO.forexValue,
      terminalLevel: coffeeDTO.terminalLevel,
      updatedDate: coffeeDTO.upDatedDate,
      convertedRangeStart: updatedPriceDetails.convertedRangeStart,
      convertedRangeEnd: updatedPriceDetails.convertedRangeEnd
    }

    try {
      const { data } = await apiAdapterCoffeeWeb.updateGlobalPriceData(payload)

      if (data?.isSuccess) {
        setEditableRowIndexs(null)
        modifyCoffeePriceData()
      } else {
        setModalState({
          showModal: true,
          message: t('SOMETHING_WENT_WRONG'),
          modalType: 'error'
        })
      }
    } catch (error) {
      setModalState({
        showModal: true,
        message: t('FAILED_TO_EDIT_GLOBAL_RAW_COFFEE_PRICES'),
        modalType: 'error'
      })
    } finally {
      setLoading(false)
    }
  }

  const modifyCoffeePriceData = () => {
    const rowIndex = editableRowIndexs

    const modifiedCOffeePriceData = globalRawCoffeePrice.map((ele, index) => {
      if (rowIndex[0] === index) {
        const { cropyear: cropYearList, ...rest } = ele

        const modifiedCropYearList = cropYearList.map((item, cropYearIndex) => {
          if (rowIndex[1] === cropYearIndex) {
            const { globalCoffeePriceDTOs: globalCoffeePriceDTOsList, ...rest } = item

            const modifiedGlobalCoffeePriceDTOsList = globalCoffeePriceDTOsList.map((qualityItem, qualityIndex) => {
              if (rowIndex[2] === qualityIndex) {
                const { globalCoffeePriceData: globalCoffeePriceDataList, ...rest } = qualityItem

                const modifiedGlobalCoffeePriceDataList = globalCoffeePriceDataList.map((priceDataEle, priceDataIndex) => {
                  if (rowIndex[3] === priceDataIndex) {
                    const { qualityName, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks } = updatedPriceDetails

                    return { ...priceDataEle, qualityName, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks }
                  }

                  return priceDataEle
                })

                return { ...rest, globalCoffeePriceData: modifiedGlobalCoffeePriceDataList }
              }

              return qualityItem
            })

            return { ...rest, globalCoffeePriceDTOs: modifiedGlobalCoffeePriceDTOsList }
          }

          return item
        })

        return { ...rest, cropyear: modifiedCropYearList }
      }

      return ele
    })

    setGlobalRawCoffeePrice(modifiedCOffeePriceData)
  }

  const onDismissFunction = () => setModalState({ showModal: false })

  const onHide = () => setModalState({ showModal: false })

  const onSuccess = () => setModalState({ showModal: false })

  const handleCurrencyDropdown = (item) => {
    setSelectedCountry(item)
    setEditableRowIndexs(null)
    fetchGlobalRawCoffeePriceOrderByCurrency(item.id)
  }

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div style={{ display: 'grid', gridTemplateColumns: '25px auto', alignItems: 'center' }}>
          <img alt={option.name} src={option.flagsUrl} className={`mr-2 flag flag-${option.iso3.toLowerCase()}`} style={{ width: '18px' }} />
          <div>{option.nicename}</div>
        </div>
      )
    }

    return <span>{props.placeholder}</span>
  }

  const countryOptionTemplate = (option) => (
    <div className="flex align-items-center">
      <img alt={option.name} src={option.flagsUrl} className={`mr-2 flag flag-${option.iso3.toLowerCase()}`} style={{ width: '18px' }} />
      <div>{option.nicename}</div>
    </div>
  )

  return (
    <div className="global-raw-coffee-price-container" data-testid="global-raw-coffee-price-container">
      <div className="global-raw-coffee-price-headers">
        <div className="currency-dropdown">
          <span>{t('CHOOSE_ORIGIN')} :</span>
          <Dropdown style={{ width: '200px' }} size="small" value={selectedCountry} onChange={(e) => handleCurrencyDropdown(e.value)} options={countryList} optionLabel="name" placeholder="Select a Country" filter valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} className="" data-testid="country-dropdown" />
        </div>
      </div>
      <div className="global-raw-coffee-price-wrapper">
        {globalRawCoffeePrice?.map((item, index) => (
          <React.Fragment key={index}>
            {item.cropyear?.map((ele, cropYearIndex) => (
              <div key={cropYearIndex}>
                <>
                  <div className="crop-year-main-header">
                    <div className="country-and-crop-year">
                      <div className="country-with-flag">
                        <img src={item.flagUrl} alt="Flag" className="flag-icon" title="country-flag-images-in-mobile-view" /> {item?.country}
                      </div>
                    </div>
                    <div className="coffee-labeling">
                      {item?.country} {t('COFFEE')}
                    </div>
                  </div>

                  {ele?.globalCoffeePriceDTOs.map((qualityItem, childIndex) => {
                    const isToday = (() => {
                      const today = new Date()
                      const updatedDate = new Date(qualityItem.upDatedDate)

                      return updatedDate.getDate() === today.getDate() && updatedDate.getMonth() === today.getMonth() && updatedDate.getFullYear() === today.getFullYear()
                    })()

                    const textColorClass = isToday ? 'updated-on-labeling' : 'updated-date-text-color'

                    return (
                      <div className="global-raw-coffee-price-table" key={childIndex}>
                        <table className="each-table" key={index}>
                          <thead className="global-raw-coffee-price-table-header">
                            <tr className="crop-year-th">
                              <th colSpan={8}>
                                <div className="crop-year-div">
                                  <div>
                                    {t('CROP_YEAR')} : {ele?.cropyear}
                                  </div>
                                  <div className={textColorClass}>
                                    {t('UPDATED_ON')} : {qualityItem.upDatedDate}
                                  </div>
                                  <div className="forex-type-value">
                                    {qualityItem.forexType} : {qualityItem.forexValue}
                                  </div>
                                </div>
                              </th>
                            </tr>
                            <tr className="top-first-th-row">
                              <th className="sl-no-th">{childIndex + 1}</th>
                              <th className="quality-th">{t('QUALITY')}</th>
                              <th className="terminal-th" colSpan={2}>
                                {qualityItem.terminal} : {qualityItem.terminalLevel}
                              </th>
                              <th className="terminal-th" colSpan={2}>
                                {t('CONV_TO')}
                              </th>
                              <th className="remarks-th">{t('REMARKS')}</th>
                              <th className="actions-th">{t('ACTIONS')}</th>
                            </tr>
                            <tr>
                              <th className="sl-no-heading">{t('SL')}</th>
                              <th className="quality-group-name-heading">{qualityItem?.qualityGroupName}</th>
                              <th className="between-heading" colSpan={2}>
                                {t('BETWEEN')}
                              </th>
                              <th className="between-heading" colSpan={2}>
                                {t('BETWEEN')}
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody className="global-raw-coffee-price-table-body">
                            {qualityItem?.globalCoffeePriceData.map((element, qualityNameIndex) => (
                              <tr key={qualityNameIndex}>
                                {editableRowIndexs?.[0] === index && editableRowIndexs?.[1] === cropYearIndex && editableRowIndexs?.[2] === childIndex && editableRowIndexs?.[3] === qualityNameIndex ? (
                                  <>
                                    <td>{qualityNameIndex + 1}</td>
                                    <td className={`quality-name ${element?.rangeStart >= element?.previousRangeStart && element?.rangeEnd >= element?.previousRangeEnd ? 'high-value' : 'low-value'}`} onClick={() => handleSelectQualityName(selectedCountry?.id, item?.country, ele?.cropyear, element?.qualityName, ele.globalCoffeePriceDTOs[0].forexType, item?.flagUrl, element?.remarks, qualityItem.forexValue, qualityItem.qualityGroupName)}>
                                      <div className="quality-name-popup-icon">
                                        {element?.qualityName}
                                        <img className="popup-icon" src={popupIcon} alt="popup-icon" title="global-history-popup-icon" />
                                      </div>
                                    </td>
                                    <td className="between">
                                      <InputText className="p-inputtext-sm" type="number" name="rangeStart" onChange={(e) => handleInputChange(e)} value={updatedPriceDetails.rangeStart} placeholder="Range Start" data-testid="range-start" />
                                    </td>
                                    <td className="between">
                                      <InputText className="p-inputtext-sm" type="number" name="rangeEnd" onChange={(e) => handleInputChange(e)} value={updatedPriceDetails.rangeEnd} placeholder="Range End" data-testid="range-end" />
                                    </td>
                                    <td className="between">
                                      <InputText className="p-inputtext-sm" type="number" name="convertedRangeStart" onChange={(e) => handleInputChange(e)} value={updatedPriceDetails.convertedRangeStart} placeholder="Conv Range Start" data-testid="converted-range-start" />
                                    </td>
                                    <td className="between">
                                      <InputText className="p-inputtext-sm" type="number" name="convertedRangeEnd" onChange={(e) => handleInputChange(e)} value={updatedPriceDetails.convertedRangeEnd} placeholder="Conv Range End" data-testid="converted-range-end" />
                                    </td>
                                    <td className="remarks">
                                      <InputText className="p-inputtext-sm" name="remarks" onChange={(e) => handleInputChange(e)} value={updatedPriceDetails.remarks} placeholder="Remarks" data-testid="remarks" />
                                    </td>
                                    <td className="actions-td">
                                      <div>
                                        <Button type="button" icon="pi pi-save" className="pi-edit-icon" tooltip={t('SAVE')} onClick={() => handleClickSaveButton(index, cropYearIndex, childIndex, qualityNameIndex)} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="save-button" />
                                        <Button type="button" icon="pi pi-times" className="pi-edit-icon" tooltip={t('CANCEL')} onClick={() => handleClickCancelButton()} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="cancel-button" />
                                      </div>
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td>{qualityNameIndex + 1}</td>
                                    <td className={`quality-name ${element?.rangeStart >= element?.previousRangeStart && element?.rangeEnd >= element?.previousRangeEnd ? 'high-value' : 'low-value'}`} onClick={() => handleSelectQualityName(selectedCountry?.id, item?.country, ele?.cropyear, element?.qualityName, ele.globalCoffeePriceDTOs[0].forexType, item?.flagUrl, element?.remarks, qualityItem.forexValue, qualityItem.qualityGroupName)}>
                                      <div className="quality-name-popup-icon">
                                        {element?.qualityName}
                                        <img className="popup-icon" src={popupIcon} alt="popup-icon" title="global-history-popup-icon" />
                                      </div>
                                    </td>
                                    <td className={`between ${element?.rangeStart >= element?.previousRangeStart ? 'high-value' : 'low-value'}`}>{element?.rangeStart}</td>
                                    <td className={`between ${element?.rangeEnd >= element?.previousRangeEnd ? 'high-value' : 'low-value'}`}>{element?.rangeEnd}</td>
                                    <td>{element?.convertedRangeStart}</td>
                                    <td>{element?.convertedRangeEnd}</td>
                                    <td className="remarks">{element?.remarks}</td>
                                    <td className="actions-td">
                                      <Button type="button" icon="pi pi-pencil" className="pi-edit-icon" tooltip={t('EDIT')} onClick={() => handleClickEditButton(index, cropYearIndex, childIndex, qualityNameIndex)} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="edit-button" />
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="end-divider-wrapper" data-testid="end-divider-wrapper">
                          <div className="end-divider-dots"></div>
                          <div className="end-divider-line"></div>
                          <div className="end-divider-dots"></div>
                        </div>
                      </div>
                    )
                  })}
                </>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
      {noDataFound && (
        <div className="no-data-found">
          {/* <img src={NoData} alt="NoDataFound" className="no-data-found-image" title="no-data-image-in-global-raw-coffee-price" /> */}
          <div className="no-data-text"> {t('NO_DATA_FOUND_FOR_THIS_COUNTRY')}</div>
        </div>
      )}
      <HistoryDataPopUp selectedQualityForHistoryData={selectedQualityForHistoryData} setSelectedQualityForHistoryData={setSelectedQualityForHistoryData} setLoading={'setLoading'} />
      <DialogModal {...modalState} onDismiss={onDismissFunction} onRetry={commonMethods.handleRetry} onHide={onHide} onSuccess={onSuccess} onConfirmation={modalState?.confirmAction} />
    </div>
  )
}

export default Loader(GlobalRawCoffeePrices)
